module.exports = __webpack_public_path__ + "img/grid2.1fc31aa.png";